import React from 'react';

import { HOME } from '@constants/routes';
import { Background, LoaderContainer, Image } from './styles';

export const AppLoader = () => (
  <LoaderContainer>
    <Background />
    <Image alt="Loader image" src={`${HOME}/fpay-logo-v1.svg`} />
  </LoaderContainer>
);
